// removed by extract-text-webpack-plugin
module.exports = {"default-font-family":"Circular, sans-serif","ixt-blue-600":"#205779","ixt-red":"#FF5555"};


//////////////////
// WEBPACK FOOTER
// ./src/components/specimen-examples/ReactSpecimenExample.css
// module id = 573
// module chunks = 2